// The pages shown instead of the app: while starting, during maintenance,
// when a first visit has no internet, and for an address that doesn't exist.
import { Link } from 'react-router-dom';
import { useAppData } from '@/app/AppData';
import { usePageTitle } from '@/app/usePageTitle';
import { t } from '@/l10n/strings';
import { Button, EmptyArt, LogoMark } from '@/ui/controls';
import { Icon } from '@/ui/Icon';

function Centered({ children }: { children: React.ReactNode }) {
  return (
    <main className="empty" style={{ minHeight: '100vh', justifyContent: 'center' }}>
      {children}
    </main>
  );
}

export function StartingPage() {
  return (
    <Centered>
      <div style={{ animation: 'enter .6s var(--ease-out) both' }}>
        <LogoMark size={64} />
      </div>
      <span className="vh" role="status">
        {t('commonLoading')}
      </span>
    </Centered>
  );
}

export function MaintenancePage() {
  const { config } = useAppData();
  usePageTitle(t('maintenanceTitle'));
  return (
    <Centered>
      <span className="tile tile--lg">
        <Icon name="wrench" size={26} />
      </span>
      <h1 className="display">{t('maintenanceTitle')}</h1>
      <p className="body-lg muted">{config.maintenanceMessage || t('webMaintenanceMessage')}</p>
      <Button variant="action" onClick={() => window.location.reload()}>
        {t('commonTryAgain')}
      </Button>
    </Centered>
  );
}

export function SignInFailedPage() {
  usePageTitle(t('startupConnectToGetStarted'));
  return (
    <Centered>
      <span className="tile tile--lg">
        <Icon name="wifioff" size={26} />
      </span>
      <h1 className="display">{t('startupConnectToGetStarted')}</h1>
      <p className="body-lg muted">{t('startupPaidlarkNeedsTheInternetOnce')}</p>
      <Button variant="action" onClick={() => window.location.reload()}>
        {t('commonTryAgain')}
      </Button>
    </Centered>
  );
}

export function NotFoundPage() {
  usePageTitle(t('webNotFoundTitle'));
  return (
    <div className="empty" style={{ minHeight: '70vh', justifyContent: 'center' }}>
      <EmptyArt badge="search" />
      <h1 className="display">{t('webNotFoundTitle')}</h1>
      <p className="body muted">{t('routeNotFound')}</p>
      <Link to="/home" className="btn btn--action">
        {t('webGoToDashboard')}
      </Link>
    </div>
  );
}
